export const Windows =
    [
        {
            id: 0,
            key: 'documents',
            title: 'Mes photos',
            image: require('../img/icons/dossier.png'),
            active: false,
            selected: false,
            position: 0,
            fullScreen: false,
            onDesktop: true
        },
        {
            id: 1,
            key: 'notes',
            title: 'Notes utiles - Bloc-notes',
            image: require('../img/icons/notes.png'),
            active: false,
            selected: false,
            position: 0,
            fullScreen: false,
            onDesktop: true
        },
        {
            id: 2,
            key: 'messenger',
            title: 'Messagerie',
            image: require('../img/icons/msn.png'),
            active: false,
            selected: false,
            position: 0,
            fullScreen: false,
            onDesktop: true
        },
        {
            id: 3,
            key: 'mail',
            title: 'Boite mail',
            image: require('../img/icons/mail.png'),
            active: false,
            selected: false,
            position: 0,
            fullScreen: false,
            onDesktop: true
        },
        {
            id: 4,
            key: 'webcam',
            title: 'Webcam',
            image: require('../img/icons/webcam.png'),
            active: false,
            selected: false,
            position: 0,
            fullScreen: false,
            onDesktop: true
        },
        {
            id: 5,
            key: 'destination',
            title: 'Itinéraire Destination',
            image: require('../img/icons/gps.png'),
            active: false,
            selected: false,
            position: 0,
            fullScreen: false,
            onDesktop: true
        },
        {
            id: 6,
            key: 'image',
            title: 'Aperçu des images',
            image: require('../img/picto-image.png'),
            active: false,
            selected: false,
            position: 0,
            fullScreen: false,
            onDesktop: false
        }
    ]